import * as React from 'react';
import { memo } from 'react';

const SvgBedSide = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.125 13.125V6.25h8.125a2.5 2.5 0 0 1 2.5 2.5v4.375M1.25 16.25V3.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M1.25 13.125h17.5v3.125M8.125 6.25H1.25", stroke: "currentColor", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgBedSide);

export { Memo as default };
